import {APIClient} from '../utils/APIClient';
import {API_URL} from '../settings/local_settings';

// Capa API del uso del portal y del asistente.
//
// Dos endpoints, uno por superficie:
//   `GET client/<id>/portal-usage/`        → el detalle dentro del tab Portal
//   `GET agency/portal-usage/overview/`    → la adopción en todos los clientes de la agencia
//
// La tercera superficie (la card del Panel) NO tiene endpoint propio: su resumen viaja adentro de
// `GET client/<id>/panel/` (`portal.usage`), que ya se pedía. Sumar una llamada al endpoint más
// caliente de la app para pintar tres líneas de una card no se paga.
//
// Todo rechazo del gate vuelve como 404 uniforme, nunca 403: distinguir "no existe" de "existe
// pero no es tuyo" deja enumerar los clientes de otra agencia probando ids.
//
// `tz_offset` va en minutos con el signo de JS (`Date.getTimezoneOffset()`, positivo al oeste de
// UTC): el backend corta con él las semanas de la serie. Si no llega, asume UTC — y ahí la semana
// del cliente puede correrse un día.

const DEFAULT_WINDOW_DAYS = 30;

function windowQuery(days) {
    const tzOffset = new Date().getTimezoneOffset();
    return `days=${encodeURIComponent(days || DEFAULT_WINDOW_DAYS)}&tz_offset=${tzOffset}`;
}

export const PortalUsageApi = {
    /** El detalle de UN cliente: contadores, serie semanal, conversaciones y navegación. */
    getClientUsage(clientId, {days} = {}) {
        const url = `${API_URL}client/${encodeURIComponent(clientId)}/portal-usage/?${windowQuery(days)}`;
        return new APIClient(url).call('GET');
    },

    /** El ranking de adopción de TODOS los clientes. Los que no usaron viajan en cero, no se omiten. */
    getAgencyOverview({days} = {}) {
        const url = `${API_URL}agency/portal-usage/overview/?${windowQuery(days)}`;
        return new APIClient(url).call('GET');
    },
};
